export interface defaultSelectedOption {
    id: number,
    value: string
}

export type ComboSelectedOption = defaultSelectedOption | null;

export function getListComboboxFormat(data: Array<string | number>) {
    return data.map((item, index) => {
        return {
            id: index,
            value: item.toString()
        }
    })
}